// JavaScript Document

function initFormModal() {


    const documentBody = document.querySelector('body');


    let erroralert, sendingalert, formHolder, bsformModal,inputStelle,inputComment;

    function validationError() {

        const formModal = document.getElementById('formModal');

        var topY = offset(formHolder).top;  

        TweenMax.to(formModal, 0.6, {
            scrollTo:{
                y: topY, 
                //autoKill: true
            }, 
            ease:Power2.easeInOut
         });

        erroralert.classList.remove('d-none'); 
        sendingalert.classList.add('d-none');


    }

    function showSendingAlert(html) { 

        const formCollapse = document.getElementById('form-collapse');

        sendingalert.innerHTML = '';
        sendingalert.innerHTML = html;
        erroralert.classList.add('d-none'); 
        gsap.set(sendingalert, {opacity: 0});
        sendingalert.classList.remove('d-none');
         var topY = offset(formCollapse).top ;  
         //bsFormCollapse.hide();

        TweenMax.to(formCollapse, 0.2, {
                scrollTo:{
                    y: topY, 
                    //autoKill: true
                }, 
                ease:Power2.easeInOut,
                delay: 0.9,
             });

        gsap.to(formCollapse, 0.8, {height:0, ease:Power2.easeInOut, onComplete: function(){ 

            setTimeout(function(){

                 gsap.to(sendingalert, 0.2, {opacity:1, ease:Power2.easeInOut});

            },100)

        }});

    }

    function initFormValidation(){

        const form = document.querySelector('#form');

        // Loop over them and prevent submission
              form.addEventListener('submit', function(event) {

                if (form.checkValidity() === false) {

                    event.preventDefault();
                    event.stopPropagation();


                    validationError();


                } else {

                    event.preventDefault();
                    event.stopPropagation();


                     SendForm();
                }

                form.classList.add('was-validated');
              }, false);
    }

    function loadModal(formTyp, posttId, standortId) {

        loading.show(documentBody, 'pos', 'fixed');


        var request = new XMLHttpRequest();
        //cursor.setAjaxState();
        request.open('POST', ajaxurl, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                // If successful
                openModal(formTyp, this.responseText, posttId, standortId);
            } else {
                // If fail
                openModal('<h3>Es ist ein Fehler aufgetreten</h3>');
                //console.log(this.response);
            }
        };
        request.onerror = function() {
            openModal('<h3>Es ist ein Fehler aufgetreten</h3>');
        };
        request.send('action=load_form_modal&formTyp='+formTyp+'&postId='+posttId+'&standortId=' + standortId);   
    }

    function openModal(formTyp, html, posttId, standortId) {
        loading.hide();
        const modalHTML = `
            <div class="modal fade" id="formModal" aria-hidden="true" tabindex="-1">
            <div class="modal-dialog modal-lg">
            <div class="modal-content ">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div class="modal-inner">
                        ${html}
                    </div>
            </div>
            </div>
            </div>`;  

        appendHtml(document.body, modalHTML);

        const formModal = document.getElementById('formModal');

        let bsformModal = new bootstrap.Modal('#formModal', {
            keyboard: false
        });


        if (formTyp === 'career') {


            loadAsyncScript("/wp-content/themes/possehlelectronics/js/form_lang-min.js")

            .then( data  => { 
  
                init(formTyp, posttId, standortId);

                setTimeout(function(){

                    bsformModal.show();

                    if (modal) {
                        modal.hide();
                    }


                },50);
            })

            .catch( err => {
                console.error(err);
            });
        } else {

            init(formTyp, posttId, standortId);

                setTimeout(function(){

                    bsformModal.show();

                    if (modal) {
                        modal.hide();
                    }


            },200);


        }






        formModal.addEventListener('shown.bs.modal', event => {
            _scrollSmoother.pause();

        });

        formModal.addEventListener('hidden.bs.modal', event => {
            formModal.remove();
            _scrollSmoother.unpause();
        });




    }

    function init(formTyp, posttId, standortId) {

        const formModal = document.getElementById('formModal');

        formHolder = document.getElementById('form-holder');

        erroralert    = formHolder.querySelector('.erroralert');
        sendingalert  = formHolder.querySelector('.sendingalert');

        inputStelle  = formHolder.querySelector('#inputStelle');

        inputComment = formHolder.querySelector('#inputComment');

        formHolder.querySelector('#standortId').value = standortId;
        
        inputComment.addEventListener('keyup', countCharacters, false);


        if (formTyp === 'career') {

            setLangText(standortId);



            const standortSelectItem = formModal.querySelector('.standort-select');

            const standortSelect = initStadortSelect(standortSelectItem, true);

            if (standortId) {

                standortSelect.setValue(standortId); 

            }

            const stellenSelectItem     = formModal.querySelector('.stellen-select-form');

            const stellenSelect         =  initStellenSelect(stellenSelectItem);

            if (posttId) {
                stellenSelect.setValue(posttId); 
            }

            initFileInput('file-input-multiple');


        }

        if (formTyp === 'purchasing') {
            initFileInput('file-input-multiple');
            initDropdownSelect('.purchasing-form-liste') 
        }

        initFormValidation();



    }

    function initStellenSelect(stellenDropdown) {

        const btn               = stellenDropdown.querySelector('.btn');

        const stellemItems      = stellenDropdown.querySelectorAll('.dropdown-item');

        const formModal      = document.getElementById('formModal');
        const inputStelle     =   formModal.querySelector('#inputStelle');

        stellemItems.forEach(function(stellemItem){

            stellemItem.addEventListener('click', function(e){

                e.preventDefault();
                const termId    = this.dataset.termId;
                const title     = this.getAttribute("title");
                btn.innerHTML   = title;
                inputStelle.value = title;  
            });
        });

        function setVal(postId) {

 

            const item = stellenDropdown.querySelector('[data-post-id="'+postId+'"]');

            const title     = item.getAttribute("title");
            btn.innerHTML = item.innerHTML;

            stellemItems.forEach(function(stellenItem){ 
                stellenItem.classList.remove("active");
            })
            item.classList.add("active");

            // if form input standort exist, set the value
            if (inputStelle) {
                inputStelle.value = title
            }
       

        }
        return {
            setValue: setVal,
        };



    }

    function SendForm() {



        const inputFinalize = formHolder.querySelector('#finalize');
        inputFinalize.value = 'true';

        // Get the form
        const form = formHolder.querySelector('#form');

        loading.show(formHolder.querySelector('#form-collapse'), 'neg', false);

        // Get all field data from the form
        const formdata = new FormData(form);

        //let queryString = new URLSearchParams(formdata).toString();

        setTimeout(function(){
 
            var request = new XMLHttpRequest();

            //cursor.setAjaxState();
            request.open('POST', ajaxurl, true);
            //request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
            request.onload = function () {
                    if (this.status >= 200 && this.status < 400) {
                        // If successful

                        loading.hide();
                        showSendingAlert(this.response);


                    } else {
                        // If fail
                        loading.hide();
                       setTimeout(function(){
                            showSendingAlert('<div class="alert alert-danger lead">Das Formular konnte nicht verschickt werden.</div>');
                        },400);
                    }
                };
                request.onerror = function() {
                        loading.hide();
                       setTimeout(function(){
                            showSendingAlert('<div class="alert alert-danger lead">Das Formular konnte nicht verschickt werden.</div>');
                        },400);
                };
                request.send(formdata);

        },200); 
    }

    function setLangText(standortId) {


        let langid;
        let sendtoemail = 'bewerbung@possehlelectronics.de';
        
        switch(standortId) {

            case '20':
                //lang  = 'de';
                langid  =   0;
                sendtoemail = 'bewerbung@possehlelectronics.de';
            break;
            case '72':
                //lang  = 'de';
                langid  =   0;
                sendtoemail ='bewerbung@possehlelectronics.de';
            break;
            case '19':
                //lang='de';
                langid  =   0;
                sendtoemail = 'career.de@possehlelectronics.com';
            break;
            case '75':
                //lang='de';
                langid  =   0;
                sendtoemail = 'career.de@possehlelectronics.com';
            break;
            case '21':
                //lang='nl';
                langid  =   2;
                sendtoemail = 'hr@possehlelectronics.nl';
            break;
            case '66':
                //lang='nl';
                langid  =   2;
                sendtoemail = 'hr@possehlelectronics.nl';
            break;
            case '18':
                //lang='cs';
                langid  =   1;
                sendtoemail = 'career.cz@possehlelectronics.com';
            break;
            case '68':
                //lang='cs';
                langid  =   1;
                sendtoemail = 'career.cz@possehlelectronics.com';
            break;
            case '16':
                //lang='en';
                langid  =   3;
                sendtoemail = 'linda-yan@possehlelectronics.com.cn';
            break;
            case '67':
                //lang='en';
                langid  =   3;
                sendtoemail = 'linda-yan@possehlelectronics.com.cn';
            break;
            case '15':
                //lang='en';
                langid  =   3;
                sendtoemail = 'hra@possehlelectronics.com.hk';
            break;
            case '69':
                //lang='en';
                langid  =   3;
                sendtoemail = 'hra@possehlelectronics.com.hk';
            break;
            case '14':
                //lang='en';
                langid  =   3;
                sendtoemail = 'info@possehlelectronics.com.my';
            break;
            case '71':
                //lang='en';
                langid  =   3;
                sendtoemail = 'info@possehlelectronics.com.my';
            break;
            case '13':
                ////lang='en';
                langid  =   3;
                sendtoemail = 'hrm.peshr@possehlelectronics.com.my';
            break;
            case '70':
                ////lang='en';
                langid  =   3;
                sendtoemail = 'hrm.peshr@possehlelectronics.com.my';
            break;
            case '12':
                ///lang='en';
                langid  =   3;
                sendtoemail = 'hr@possehlconnector.com';
            break;
            case '74':
                ///lang='en';
                langid  =   3;
                sendtoemail = 'hr@possehlconnector.com';
            break;
            case '11':
                //lang='es';
                langid  =   4;
                sendtoemail = 'career.mx@possehlelectronics.com';
            break;
            case '73':
                //lang='es';
                langid  =   4;
                sendtoemail = 'career.mx@possehlelectronics.com';
            break;
            default:
                //lang='de';
                langid  =   0;
        }

       

        formHolder.querySelector('h2').innerHTML = bewerbungsFormText[langid]['heading'];

        formHolder.querySelector('.erroralert').innerHTML = bewerbungsFormText[langid]['errorsecurity'];


        
        formHolder.querySelector('#standortId').value = standortId;
        formHolder.querySelector('#sendtoemail').value = sendtoemail;

        formHolder.querySelector('.standort-select .btn').dataset.title = bewerbungsFormText[langid]['titleselectstandort'];
        formHolder.querySelector('.standort-select .btn').dataset.title = bewerbungsFormText[langid]['titleselectstandort'];


        formHolder.querySelector('.stellen-select-form .btn').dataset.title = bewerbungsFormText[langid]['titleselectjob'];
        formHolder.querySelector('.stellen-select-form .btn').innerHTML = bewerbungsFormText[langid]['titleselectjob'];

        formHolder.querySelector('.stellen-select-form .dropdown-item-initial').title = bewerbungsFormText[langid]['iniselectcontainer'];
        formHolder.querySelector('.stellen-select-form .dropdown-item-initial').innerHTML = bewerbungsFormText[langid]['iniselectcontainer'];

        formHolder.querySelector('.stellen-select-form .dropdown-header-ausbildungsangebote').title = bewerbungsFormText[langid]['optgroupAusbil'];
        formHolder.querySelector('.stellen-select-form .dropdown-header-ausbildungsangebote').innerHTML = bewerbungsFormText[langid]['optgroupAusbil'];

        formHolder.querySelector('.stellen-select-form .dropdown-header-studien').title = bewerbungsFormText[langid]['optgroupThesis'];
        formHolder.querySelector('.stellen-select-form .dropdown-header-studien').innerHTML = bewerbungsFormText[langid]['optgroupThesis'];

        formHolder.querySelector('.stellen-select-form .dropdown-item-praktikum').title = bewerbungsFormText[langid]['schulerselectcontainer'];
        formHolder.querySelector('.stellen-select-form .dropdown-item-praktikum').innerHTML = bewerbungsFormText[langid]['schulerselectcontainer'];


        formHolder.querySelector('.lang-field[data-name="inputFirstName"]').innerHTML = bewerbungsFormText[langid]['vornamelabel'];

        formHolder.querySelector('.lang-field[data-name="inputName"]').innerHTML = bewerbungsFormText[langid]['nachnamelabel'];

        formHolder.querySelector('.lang-field[data-name="inputEmail"]').innerHTML = bewerbungsFormText[langid]['emaillabel'];

        formHolder.querySelector('.lang-field[data-name="inputPhone"]').innerHTML = bewerbungsFormText[langid]['telefonlabel'];

        formHolder.querySelector('.lang-field[data-name="inputFileMultiple-alert"]').innerHTML = bewerbungsFormText[langid]['fileinfo'];

        // formHolder.querySelector('.lang-field[data-name="inputFileMultiple"]').innerHTML = "lorem ipsum"+standortId;

        formHolder.querySelector('.lang-field[data-name="inputComment"]').innerHTML = bewerbungsFormText[langid]['anmerkunglabel'];

        formHolder.querySelector('.lang-field[data-name="checkDataProtection"]').innerHTML = bewerbungsFormText[langid]['privacyContent'];

        formHolder.querySelector('.lang-field[data-name="submit"]').innerHTML = bewerbungsFormText[langid]['submit']; 


    }

    function countCharacters(e) {


        let textEntered, countRemaining, counter;  

        textEntered = e.srcElement.value; 
        counter = (1000 - (textEntered.length));
        countRemaining = e.srcElement.parentNode.querySelector('#charactersRemaining'); 
          
          if (counter <= 10) {
              
              countRemaining.classList.add('text-danger');
              countRemaining.classList.remove('text-muted'); 
              
              
          } else {
              countRemaining.classList.remove('text-danger');
              countRemaining.classList.add('text-muted');
          }
           
        countRemaining.textContent = counter +'/1000';    
       
    }



    return {

        loadModal: loadModal,
        setLangText: setLangText
    };


}
